($ => {

	'use strict';

	function init() {

		showDefinition()
        
	}

    function showDefinition(){

        const definitionLinks = document.querySelectorAll('a[href*="definitions"]');

		definitionLinks.forEach((definitionLink) => {

			let splitHref = definitionLink.href.split('/')
			let slug = splitHref.length > 1 ? splitHref[splitHref.length - 2] : '';

            definitionLink.addEventListener('click', (event) => {

				definitionLink.classList.add('loading')
                
                jQuery.post(
					MyAjax.ajaxurl,
					{
						'action': 'get_definition_popup',
						'slug': slug,
					},
					function(response){
		
						var json = JSON.parse(response);
		
						if(json.success) {

							definitionLink.classList.remove('loading')
	
                            document.getElementById('appendZone').innerHTML += json.data

                            let closeDefinitionLinks = document.querySelectorAll('.definitionPopup');

                            closeDefinitionLinks.forEach((closeDefinitionLink) => {

								closeDefinitionLink.querySelector('.definitionPopup__content').addEventListener('click', (e) => {

									e.stopPropagation()
									
								})

                                closeDefinitionLink.querySelector('.definitionPopup__content__close').addEventListener('click', (e) => {

									e.stopPropagation()
                                    
                                    closeDefinitionLink.remove()

                                })

								closeDefinitionLink.addEventListener('click', () => {
                                    
                                    closeDefinitionLink.remove()

                                })


                            })

						}
					}
				)

                event.preventDefault();
                return false;

            })
        })

    }

	$(document).ready(() => {
		init();
	});

})(jQuery);
